/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import axios from 'axios';
import moment from 'moment';

import {
  CustomException,
  getIdToken,
  getListItemsCount,
  isResponseValid,
  throwSAPError,
  downloadExcel,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  SET_QUOTATION_ORDER_DATA_STATUS,
  SET_QUOTATION_ORDER_DATA,
  SELECT_QUOTATION,
  SET_QUOTATION_DETAIL_STATUS,
  GET_QUOTATION_DETAIL_DATA,
} from '../helpers/types';

const invalidResponseMsgText = i18n.t('quotationScreenTranslations:INVALID_RESPONSE');

export const getQuotationTableData = (
  skip,
  top,
  enqueueSnackbar = () => {},
  filterStr = ''
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner, selectedSalesOrgData } = auth;
    const { SalesOrg, DisCha, Division } = selectedSalesOrgData;

    dispatch({
      type: SET_QUOTATION_ORDER_DATA_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);
    const filter = `SoldToParty eq '${BusinessPartner}' and SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and OrganizationDivision eq '${Division}'`;
    let config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: filter,
        $orderby: 'SalesQuotation desc',
      },
    };
    if (filterStr !== '') {
      config = {
        ...config,
        params: {
          ...config.params,
          $filter: `${filter} and ${filterStr}`,
        },
      };
    }
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_PB2B_SRV/ZAE_I_Quotation_23`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
        $expand: 'to_QuotationItems',
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_PB2B_SRV`,
      });
      const response = await MainService.get('/ZAE_I_Quotation_23', config).catch(throwSAPError);
      if (isResponseValid(response)) {
        const Data = response.data.d.results.map(r => ({
          ...r,
          QuotationValidTo: moment(r.QuotationValidTo).format('MMMM DD, YYYY'),
          ConcatSuperMaterials:
            r.to_QuotationItems.results.length > 0
              ? r.to_QuotationItems.results[0].ConcatSuperMaterials
              : '',
        }));

        Data.sort((a, b) => b.SalesOrder - a.SalesOrder);

        dispatch({
          type: SET_QUOTATION_ORDER_DATA,
          payload: {
            data: Data,
            listCount,
          },
        });
      } else {
        throw new CustomException(invalidResponseMsgText);
      }
    }
  } catch (error) {
    dispatch({
      type: SET_QUOTATION_ORDER_DATA_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('quotationScreenTranslations:UNABLE_TO_LOAD_DATA'),
      },
    });

    enqueueSnackbar(i18n.t('quotationScreenTranslations:UNABLE_TO_LOAD_DATA'), {
      variant: 'error',
    });
  }
};

export const selectQuotation = quotation => ({
  type: SELECT_QUOTATION,
  payload: quotation,
});

export const getQuotationData = quotation => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner, selectedSalesOrgData } = auth;
    const { SalesOrg, DisCha, Division } = selectedSalesOrgData;
    dispatch({
      type: SET_QUOTATION_DETAIL_STATUS,
      payload: { isQuotationDetailLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);
    const filter = `SoldToParty eq '${BusinessPartner}' and SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and OrganizationDivision eq '${Division}'`;

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `${filter}  and SalesQuotation eq '${quotation}'`,
        $expand: 'to_QuotationItems',
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}`,
    });
    const response = await MainService.get('/ZAE_PB2B_SRV/ZAE_I_Quotation_23', config).catch(
      throwSAPError
    );
    if (isResponseValid(response)) {
      // const Data = response.data.d.results.map(r => ({
      //   ...r,
      //   QuotationValidTo: moment(r.QuotationValidTo).format('MMMM DD, YYYY'),
      // }));
      dispatch({
        type: GET_QUOTATION_DETAIL_DATA,
        payload: {
          selQuotationDetailData: response.data.d.results[0],
          // isQuotationDetailLoading: false,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_QUOTATION_DETAIL_STATUS,
      payload: { isQuotationDetailLoading: false },
    });
  }
};

export const getAllQuotationsData = (skip, enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner, selectedSalesOrgData } = auth;
    const { SalesOrg, DisCha, Division } = selectedSalesOrgData;
    const idToken = await getIdToken(dispatch, getState);
    const filter = `SoldToParty eq '${BusinessPartner}' and SalesOrganization eq '${SalesOrg}' and DistributionChannel eq '${DisCha}' and OrganizationDivision eq '${Division}'`;

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: filter,
        $orderby: 'SalesQuotation desc',
        $expand: 'to_QuotationItems',
      },
    };

    config.params = {
      ...config.params,
      $skip: skip,
    };

    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });
    const response = await MainService.get('/ZAE_I_Quotation_23', config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const Data = response.data.d.results.map(r => {
        const { to_QuotationItems } = r;
        const { results } = to_QuotationItems;
        return {
          // 'Part Number': 'AAAA',
          // 'Suprseded Part Number': 'DDDD',
          'Sales Quotation': results[0].SalesDocument,
          'SuperSeeded Part No': results[0].ConcatSuperMaterials,
          'Sales Document Item': results[0].SalesDocumentItem,
          Material: results[0].Material,
          Description: results[0].MaterialName,
          'Requested Quantity': results[0].OrderQuantity,
          'Available in WH': results[0].Stock,
          'Unit Price': results[0].NetPriceAmount,
          // 'VAT@5%': '0.55',
          // Amount: '11.55',
          'Total Price': results[0].NetAmount,
          'Total Tax': results[0].TaxAmount,
          'Total Amount': results[0].TotalAmount,
        };
      });
      Data.sort((a, b) => b.SalesQuotation - a.SalesQuotation);
      downloadExcel(Data, 'AllQuotation.xlsx', 'Quotation');
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_QUOTATION_ORDER_DATA_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('quotationScreenTranslations:UNABLE_TO_LOAD_DATA'),
      },
    });

    enqueueSnackbar(i18n.t('quotationScreenTranslations:UNABLE_TO_LOAD_DATA'), {
      variant: 'error',
    });
  }
};
